<template>
  <div class="e-block-wrap">
    <div class="e-block">
      <div class="e-block__scroll" :style="{ minHeight: containerHeight }">
        <div class="e-block__title">
          {{ currentQuestion.title }}
          <info-icon size="large" v-if="currentQuestion.hint">{{ currentQuestion.hint }}</info-icon>
        </div>
        <div class="e-selector-label">{{ currentQuestion.dopLabel ? `${currentQuestion.dopLabel} ` : '' }}{{isMultiSelect ? 'you can select multiple options:' : 'Choose one:'}}</div>
        <div class="e-selector-block">
          <div class="e-selector-wrap" :class="{'e-selector-wrap--50': isMultiSelect }">
            <div v-for="(options, c) in optionsByColumns"
                 class="e-selector-column"
                 :class="{'e-selector-column--50': isMultiSelect }"
                 :key="`col-${c}`">
              <div
                v-for="(option, index) in options"
                class="e-selector"
                :class="{
                  'e-selector--small': optionsByColumns.length > 1,
                  'e-selector--yes': option.typeYes,
                  'e-selector--no': option.typeNo,
                  'e-selector--multi': isMultiSelect,
                  'e-selector--selected': selectedOptions.indexOf(option.value) > -1
                }"
                @click.self="proceed(option)"
                :key="`item-${c}-${index}`">
                <span v-if="isMultiSelect" class="e-selector__value" @click.self="proceed(option)">{{ option.value }}</span>
                <span class="e-selector__title" @click.self="proceed(option)">{{ option.title }}</span>
                <info-icon size="small" class="e-tooltip--right" v-if="option.hint">{{ option.hint }}</info-icon>
              </div>
            </div>
          </div>
        </div>
        <tip v-if="currentQuestion.tip" :text="currentQuestion.tip" />
      </div>
    </div>
    <div class="e-bottom-navbar">
      <div class="e-row e-row--gutters">
        <div class="e-col-auto e-order-sm-2" :class="{ 'e-col-sm-12': !isMultiSelect, 'e-col-sm-6': isMultiSelect }">
          <button class="e-btn e-btn--prev" @click.prevent="previous">Previous</button>
        </div>
        <div class="e-col-auto e-col-sm-6 e-order-sm-3" v-if="isMultiSelect">
          <button class="e-btn e-btn--help e-btn--no-text" @click.prevent="nextQuestion(needHelp)"><span>Help</span></button>
        </div>
        <div class="e-col"></div>
        <div class="e-col-auto e-col-sm-12 e-order-sm-1" v-if="isMultiSelect">
          <button class="e-btn e-btn--next" @click.prevent="nextForMultiple">Proceed</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import InfoIcon from '@/components/ui/InfoIcon.vue';
import Tip from '@/components/ui/Tip.vue';
import { FLOW_TYPE } from '@/store';
import { switchToResidential, needHelp } from '@/utils/commercial-flow';

export default {
  components: {
    InfoIcon,
    Tip,
  },
  name: 'Selector',
  data() {
    return {
      needHelp,
      selectedOptions: [],
    };
  },
  mounted() {
    this.selectedOptions = this.selectedCabinetOptions;
  },
  computed: {
    ...mapState(['selectedFlow', 'containerHeight', 'selectedCabinetOptions']),
    ...mapGetters(['currentQuestion']),
    optionsByColumns() {
      const options = JSON.parse(JSON.stringify(this.currentQuestion.options));
      if (options.length <= 4) {
        return [options];
      }
      const middle = Math.ceil(options.length / 2);
      return [
        options.slice(0, middle),
        options.slice(middle),
      ];
    },
    isMultiSelect() {
      return this.currentQuestion.multiple === true;
    },
  },
  methods: {
    ...mapActions(['nextQuestion', 'previousQuestion', 'addParamToFilter', 'setSelectedFlow', 'setSelectedCabinetOptions']),
    previous() {
      this.previousQuestion();
    },
    proceed(option) {
      if (this.isMultiSelect) {
        if (this.selectedOptions.indexOf(option.value) > -1) {
          this.selectedOptions = this.selectedOptions.filter((item) => item !== option.value);
        } else {
          this.selectedOptions.push(option.value);
        }
      } else if (option.nextId === switchToResidential) {
        this.setSelectedFlow(FLOW_TYPE.RESIDENTIAL);
      } else {
        if (this.currentQuestion.paramName) {
          this.addParamToFilter({ name: this.currentQuestion.paramName, value: option.value });
        }
        if (option.params) {
          Object.entries(option.params).forEach((entry) => {
            this.addParamToFilter({ name: entry[0], value: entry[1] });
          });
        }
        this.nextQuestion(option.nextId);
      }
    },
    nextForMultiple() {
      this.setSelectedCabinetOptions(this.selectedOptions);
      this.nextQuestion(this.currentQuestion.nextId);
    },
  },
};
</script>

<style lang="scss">

</style>
